import React, { Component } from 'react'
import { connect } from 'react-redux'

class approveLayout extends Component {
  constructor() {
    super()
    this.state = {
      totalIN: [],
      totalAC: 0,
      totalEX: 0,
    }
  }

  componentDidMount() {}

  render() {
    return (
      <div>
        <div className="page-breadcrumb">{this.props.children}</div>
      </div>
    )
  }
}

const mapState = () => ({})

const mapDispatch = () => {
  return {}
}
export default connect(mapState, mapDispatch)(approveLayout)
